import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export default class ModalShowChangeUIDLog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userId: null,
            changeUidLogs: [],
            loading: false
        };

        this.getChangeUidLogs = this.getChangeUidLogs.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userId !== this.props.userId) {
            this.setState({
                userId: nextProps.userId,
                changeUidLogs: []
            });

            if (nextProps.userId !== null && nextProps.userId !== undefined) {
                this.getChangeUidLogs(nextProps.userId);
            }
        }
    }

    componentDidMount() {
        if (this.props.userId !== null && this.props.userId !== undefined) {
            this.getChangeUidLogs(this.props.userId);
        }
    }

    getChangeUidLogs(userId) {
        this.setState({ loading: true });

        const url = global.config.apiDomain + '/rest/admin/getChangeUidLogs';

        axios.post(
            url,
            { userId },
            {
                headers: { 'Content-Type': 'application/json' }
            }
        )
            .then(res => {
                this.setState({
                    changeUidLogs: res?.data?.list || [],
                    loading: false
                });
            })
            .catch(err => {
                console.error('Error fetching change UID logs:', err);
                this.setState({ loading: false });
                toast.error('FAILED');
            });
    }

    render() {
        const { changeUidLogs, loading } = this.state;

        return (
            <div>
                <div
                    className="modal fade"
                    id="modalShowChangeUIDLog"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="modalShowChangeUIDLogLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="modalShowChangeUIDLogLabel">
                                    Lịch sử thay đổi UID
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                {loading ? (
                                    <div className="text-center">
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                ) : changeUidLogs && changeUidLogs.length > 0 ? (
                                    changeUidLogs.map((log, index) => (
                                        <div key={index} className="card mb-3">
                                            <div className="card-body">
                                                <h6 className="card-title">Lần đổi UID #{index + 1}</h6>
                                                <p className="card-text">
                                                    <strong>UID cũ:</strong> {log.oldUid ?? ''}
                                                </p>
                                                <p className="card-text">
                                                    <strong>UID mới:</strong> {log.newUid ?? ''}
                                                </p>
                                                <p className="card-text">
                                                    <strong>Thời gian:</strong>{' '}
                                                    {log.changedAt ? new Date(log.changedAt).toLocaleString() : ''}
                                                </p>
                                                {log.changedByUid !== undefined && log.changedByUid !== null && log.changedByUid !== 0 ? (
                                                    <p className="card-text">
                                                        <strong>UID Người thay đổi:</strong> {log.changedByUid}
                                                    </p>
                                                ) : (
                                                    <p className="card-text">
                                                        <strong>UID Người thay đổi:</strong> Không rõ
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p>Không có dữ liệu</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
